/* eslint-disable no-underscore-dangle */
import { SearchablePublicationSheetInstantSearch } from '@livv/models';
import { Typography } from '@mui/material';
import { Hit, HitAttributeSnippetResult } from 'instantsearch.js';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import { Snippet } from 'react-instantsearch';

export interface SnippetWithNotes {
    _snippetResult: {
        notes?: HitAttributeSnippetResult[];
    };
}

const NotesSnippet: FC<{
    hit: Hit<SearchablePublicationSheetInstantSearch> & SnippetWithNotes;
}> = ({ hit }) => {
    const { t } = useTranslation('common');
    const matchedNotes = hit._snippetResult.notes?.filter(
        ({ matchLevel }) => matchLevel === 'full',
    );

    return (
        matchedNotes &&
        matchedNotes?.length > 0 && (
            <Typography sx={{ display: 'block', mt: 0.25 }} variant="caption">
                {`${t('bibliography.label')} : `}
                <Snippet
                    attribute="notes"
                    hit={{ ...hit, _snippetResult: { notes: matchedNotes } }}
                />
            </Typography>
        )
    );
};

export default NotesSnippet;
